import React from "react";

import useAxios from "../hooks/useAxios";
import axiosInstance from "../apis/gvmdesk";

//components
import TagList from "../components/TagList";
import TagItem from "../components/TagItem";
import TagInfo from "../components/TagInfo";
import TagListHeader from "../components/TagListHeader";
import LoadingCenter from "../components/LoadingCenter";

export const Tags = () => {
  const [tags, setTags, loading, error, refetch] = useAxios({
    axiosInstance,
    method: "GET",
    url: "/tags/admin"
  });

  function onDelete(id) {
    let filteredTags = tags.filter(tag => tag.id !== id);
    setTags(filteredTags);
  };

  const hasTags = tags.length ?
    tags.map(tag => <TagItem key={tag.id} tag={tag} onDelete={onDelete} />)
    : <TagInfo onClick={refetch} />;

  const isLoading = loading ? <LoadingCenter /> : hasTags;

  const isError = error ? <div>Ocorreu um erro.</div> : null;

  return (
    <div className="fk-table">
      <TagList>
        <TagListHeader />
        {isLoading}
        {isError}
      </TagList>
    </div>
  );
}

export default Tags;